import React, { useState, useEffect } from 'react';
import NavBar from '../../components/NavBar';
import Footer from '../../components/Footer';
import Cookies from 'js-cookie';
import { FaCheckCircle } from 'react-icons/fa';
import { RiCloseLine } from 'react-icons/ri';

import { requestEventCreate, requestEvents } from '../../services/requests';

const CalendarForm = () => {
	const [showAlert, setShowAlert] = useState('loading');
	const [eventSuccess, setEventSuccess] = useState(false);
	const [cardAnimation, setCardAnimation] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');
	const [categorias, setCategorias] = useState([]);
	const [form, setForm] = useState({
		titulo: '',
		descricao: '',
		categoria: '',
		local: '',
		data: '',
		horario: '',
	});

	const handleForm = (event) => {
		let chave = event.target.id;
		let valor = event.target.value;
		setForm({ ...form, [chave]: valor });
	};

	const handleListEvents = async () => {
		const events = await requestEvents();
		setCategorias(
			events.reduce((categorias, item) => {
				if (item.categoria && !categorias.includes(item.categoria)) {
					categorias.push(item.categoria);
				}
				return categorias;
			}, [])
		);
	};

	const handleSendEvent = async () => {
		const user = JSON.parse(Cookies.get('user'));

		const validarObjeto = (obj) => Object.values(obj).every(Boolean);
		const response = await requestEventCreate(form, user.token);
		if (validarObjeto(form) && !response.error) {
			setEventSuccess(true);
			setTimeout(() => {
				setCardAnimation(true);
			}, 100);
		} else {
			console.log(response.error);
			setErrorMessage(
				Object.keys(response.error).length > 1
					? 'Os campos não podem estar em branco'
					: `O campo de "${
							Object.keys(response.error)[0]
					  }" não pode estar em branco.`
			);
		}
	};
	useEffect(() => {
		handleListEvents();
		const currentPage = 'calendario';
		const validate = String(window.location.pathname).includes(currentPage);
		const localData = Cookies.get('user');
		setShowAlert(validate && localData === undefined);
	}, []);

	return (
		<div className='flex flex-col min-h-screen'>
			<NavBar />
			{eventSuccess && (
				<div
					className={`fixed rounded-md top-2/4 left-1/2 -translate-x-1/2 -translate-y-3/4 z-20 transition-all duration-500 bg-white flex flex-col items-center overflow-hidden ${
						cardAnimation
							? 'w-[60%] lg:w-[36%] xl:w-[25%] 2xl:w-[22%] h-[130px] opacity-100 scale-100'
							: 'w-0 h-0 opacity-0 scale-0'
					}`}>
					<div className='flex w-full bg-[#E3E3E3] justify-end h-[25px] rounded-t-md '>
						<button
							onClick={() => {
								setCardAnimation(false);
								setTimeout(() => setEventSuccess(false), 500);
							}}
							className='flex justify-end items-center w-[50px] bg-[#B74644] hover:bg-[#923634] h-[25px] rounded-tr-md text-white transition-all duration-500'>
							<RiCloseLine className='mx-auto scale-[150%] transition-all duration-500' />
						</button>
					</div>
					<div
						className={`flex items-center h-full justify-center transition-all duration-500 gap-4 p-6 overflow-hidden 
						w-full`}>
						<div className='text-[#32993E] content-center transition-all duration-500'>
							<FaCheckCircle className='scale-[180%] transition-all duration-500' />
						</div>
						<p className='text-[#757575] font-inter content-center sm:text-[24px] text-[18px] text-center font-semibold transition-all duration-500'>
							Evento Adicionado
						</p>
					</div>
				</div>
			)}
			<div className='text-center flex-grow mt-20 font-inter'>
				{eventSuccess && (
					<div
						onClick={() => {
							setEventSuccess(false);
							setCardAnimation(false);
						}}
						className='fixed flex w-full h-full z-10 opacity-60 bg-black'></div>
				)}
				{showAlert ? (
					<section className='bg-[#004A80] rounded-md w-[90%] sm:w-[70%] md:w-[60%] lg:w-[50%] mt-20 mx-auto my-auto'>
						<div className='py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6'>
							<div className='mx-auto max-w-screen-sm text-center'>
								<h1 className='mb-4 text-white text-5xl sm:text-6xl lg:text-7xl tracking-tight font-extrabold text-primary-600'>
									401
								</h1>
								<p className='mb-10 text-2xl sm:text-3xl md:text-4xl tracking-tight font-bold text-slate-100'>
									Acesso Negado
								</p>
								<p className='mb-7 text-sm sm:text-base md:text-lg font-light text-gray-300'>
									Você não possui permissão para acessar este
									campo. Entre em contato com o
									administrador(a) da sua unidade para
									solicitação de acesso.
								</p>
								<a
									href='/login'
									className='inline-flex hover:scale-105 transition-transform text-gray-300 bg-primary-600 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center my-4'>
									Volte para a Tela de Login
								</a>
							</div>
						</div>
					</section>
				) : (
					<div className='relative'>
						<p
							className='w-full text-[#004A80] font-semibold flex items-center justify-center text-3xl md:text-4xl
					mt-12 w-first-letter:text-xl font:inter text-[32px]'>
							Criação de Eventos
						</p>
						<hr className='w-[210px] rounded-lg sm:h-[6px] h-[4px] mx-auto my-3 mt-5 bg-[#42B9EB] dark:bg-gray'></hr>
						<div className='w-full flex justify-center mb-32'>
							<form
								className='space-y-4 md:space-y-6 mt-10 transition-all duration-300 w-[75%] sm:w-[60%] lg:w-[36%] xl:w-[25%] 2xl:w-[22%]'
								action='#'>
								<div>
									<input
										type='nome'
										name='titulo'
										id='titulo'
										onChange={handleForm}
										className=' border border-[#E3E3E3] placeholder-[#E3E3E3] text-[#757575]  sm:text-sm rounded-md focus:ring-primary-200 focus:border-primary-200 block w-full p-2.5'
										placeholder='Título do evento'
										required=''></input>
								</div>
								<div>
									<textarea
										name='descricao'
										id='descricao'
										onChange={handleForm}
										className=' border border-[#E3E3E3] placeholder-[#E3E3E3] text-[#757575] resize-none  sm:text-sm  rounded-md  block w-full p-2.5 h-[90px] text-[14px]  '
										placeholder='Descrição do Evento'
										required=''></textarea>
								</div>
								<div>
									<div className='relative w-full'>
										<select
											id='categoria'
											onChange={handleForm}
											className='appearance-none border border-[#E3E3E3] text-[#757575] text-sm rounded-md block w-full p-2 py-3 pr-10 focus:ring-blue-500 focus:border-blue-500'>
											<option value=''>
												Selecione a categoria
											</option>
											{categorias.map(
												(categoria, index) => (
													<option
														key={index + 'raw'}
														value={categoria}>
														{categoria}
													</option>
												)
											)}
										</select>
										<div className='absolute inset-y-0 right-2 flex items-center pointer-events-none'>
											<svg
												className='w-8 h-6 text-[#a8a8a8]'
												fill='none'
												stroke='currentColor'
												viewBox='0 0 24 24'
												xmlns='http://www.w3.org/2000/svg'>
												<path
													strokeLinecap='round'
													strokeLinejoin='round'
													strokeWidth={2}
													d='M19 9l-7 7-7-7'
												/>
											</svg>
										</div>
									</div>
								</div>

								<div className='block lg:flex justify-between '>
									<div className='sm:mb-0 mb-4'>
										<input
											onChange={handleForm}
											type='date'
											name='data'
											id='data'
											min={
												new Date()
													.toISOString()
													.split('T')[0]
											}
											className='border  border-[#E3E3E3] text-[#757575] sm:text-sm rounded-md focus:ring-primary-300  focus:border-primary-300 block w-full p-2.5 gray-600'
											required=''></input>
										<p
											htmlFor='remember'
											className='text-[#757575] text-start text-[10px] '>
											Insira a{' '}
											<span className='font-bold '>
												data
											</span>{' '}
											do Evento
										</p>
									</div>
									<div className=' '>
										<input
											type='time'
											name='horario'
											id='horario'
											onChange={handleForm}
											className='border w-full lg:w-[150px] rounded-md border-[#E3E3E3] text-[#757575]  sm:text-sm focus:ring-primary-600 focus:border-primary-600 block  p-2.5  -gray-600  '
											placeholder='Email'
											required=''></input>
										<p
											htmlFor='remember'
											className='text-[#757575] text-start text-[10px] '>
											Escolha o Horario de{' '}
											<span className='font-bold'>
												Inicio
											</span>
										</p>
									</div>
								</div>
								<div>
									<input
										type='text'
										name='local'
										id='local'
										onChange={handleForm}
										className=' border w-full border-[#E3E3E3] text-[#757575] rounded-md  sm:text-sm focus:ring-primary-600 focus:border-primary-600 block p-2.5 placeholder:text-[#E3E3E3]   '
										placeholder='Local do evento'
										required=''></input>
								</div>
								<div className='relative'>
									<div className='text-red-600 text-[12px]'>
										{errorMessage.length > 0 &&
											errorMessage}
									</div>
									<button
										onClick={handleSendEvent}
										type='button'
										className={`text-white enabled:bg-[#004A80] 
												enabled:hover:bg-[#13335A] bg-blue-300 focus:ring-4 focus:ring-blue-300 font-light rounded-md text-md sm:w-[65%] px-[40px] py-2.5 me-2 mb-2 mt-5 focus:outline-none`}>
										Adicionar Evento
									</button>
								</div>
							</form>
						</div>
					</div>
				)}
			</div>
			<div className='z-30'>
				<Footer />
			</div>
		</div>
	);
};

export default CalendarForm;
